import styled from "@emotion/styled";
var SectionContainer = /*#__PURE__*/ styled("div", {
    target: "e1yk720w0"
})("display:grid;grid-auto-flow:row dense;grid-template-columns:repeat(12,minmax(0,1fr));column-gap:1rem;:not(:last-child){margin-bottom:4rem;}", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{:not(:last-child){margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[100];
}, ";}}", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{column-gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";}");
export { SectionContainer };
